import { render } from "./Loading.vue?vue&type=template&id=e9ab6a90"
const script = {}

import "./Loading.vue?vue&type=style&index=0&id=e9ab6a90&lang=scss"
script.render = render

export default script